import type { GrantRules, PageGrantLevel } from "@/shared/types";
import { GoogleUserProfile } from "@/shared/types";
import { createContext } from "react";

export interface AuthContextType {
  user: GoogleUserProfile | null;
  grant: GrantRules;

  isAuthenticated: boolean;
  isLoading: boolean;

  getPageGrantLevel: (pageName: string) => PageGrantLevel;
  canReadPage: (pageName: string) => boolean;
  canWritePage: (pageName: string) => boolean;

  loginWithGoogleCallBack: (credential: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

